(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.controller('AgendaSettingsAgendaLabelController', ['$state', '$uibModal', 'AgendaLabel', 'SharedAgendaService', 'PaginationService', 'agendalabels', AgendaSettingsAgendaLabelControllerFn]);

    /* controlle for main agenda-settings agenda labels */
    function AgendaSettingsAgendaLabelControllerFn($state, $uibModal, AgendaLabel, SharedAgendaService, PaginationService, agendalabels) {
        var vm = this;       

        // overview service
        vm.overview = null;

        // start
        activate();


        /* new agenda label */
        vm.new = function () {
            // modal 
            var modalInstance = null;

            // open modal
            modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                animation: true,
                templateUrl: '/app/settings/agendasettings/modules/agendalabels/templates/agenda-label-details.template.html',
                controller: 'DetailAgendaLabelController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    label: function () {
                        var label = new AgendaLabel();
                        // set agenda
                        label.fK_Agenda = SharedAgendaService.currentUser().agendaId;
                        return label;
                    },
                    colors: ['AdministrationService', function (AdministrationService) {
                        return AdministrationService.colors();
                    }],
                    languages: ['AdministrationService', function (AdministrationService) {
                        return AdministrationService.languages();
                    }],
                    roles: ['AdministrationService', function (AdministrationService) {
                        return AdministrationService.labelRoles();
                    }]
                }
            });


            // when modal is closed
            modalInstance.result.then(function (item) {
                // push to array
                var label = new AgendaLabel();
                label.extend(item);
                vm.overview.add(label);
            }, function () {
                //dismissed
            });
        };


        /* show all items (includes deactivated ones) */
        vm.showAll = function () {
            $state.go($state.current.name, { all: vm.overview.data.showAll }, { reload: $state.current.name });
        };


        /* activation work */
        function activate() {
            var array = [];
            // list of agenda labels
            agendalabels.forEach(function (item) {
                var label = new AgendaLabel();
                label.extend(item);

                //push to array
                array.push(label);
            });

            // init overview Service
            vm.overview = new PaginationService(array);

            // clear
            agendalabels = null;
        } // activate
    }
})();
